import { useCallback, useEffect, useRef, useState } from "react";
import api from "../lib/api";

export function useApi(path, deps = []) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const seq = useRef(0);
  const reload = useCallback(() => {
    if (!path) { setLoading(false); return; }
    const id = ++seq.current;
    setLoading(true);
    api.get(path)
      .then((r) => { if (id === seq.current) { setData(r.data); setError(null); } })
      .catch((e) => { if (id === seq.current) setError(e); })
      .finally(() => { if (id === seq.current) setLoading(false); });
  }, [path]);
  useEffect(() => { reload(); }, [reload, ...deps]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    // Refetch when the tab regains focus so edits made on another device show up without a manual refresh.
    let last = Date.now();
    const onFocus = () => { if (document.visibilityState === "visible" && Date.now() - last > 15000) { last = Date.now(); reload(); } };
    document.addEventListener("visibilitychange", onFocus);
    window.addEventListener("focus", onFocus);
    return () => { document.removeEventListener("visibilitychange", onFocus); window.removeEventListener("focus", onFocus); };
  }, [reload]);
  return { data, loading, error, reload, setData };
}

export function useDebounced(value, ms = 350) {
  const [v, setV] = useState(value);
  useEffect(() => { const t = setTimeout(() => setV(value), ms); return () => clearTimeout(t); }, [value, ms]);
  return v;
}
